// components/user/Container.js
import React from "react";
import { useNode } from "@craftjs/core";
import { useThemeStore } from "@state/theme";

interface ContainerBuilderComponentProps {
  children?: React.ReactNode;
}

interface ContainerPreviewComponentProps {
  children?: React.ReactNode;
  connect?: any;
  drag?: any;
}

const ContainerBuilderComponent = (props: ContainerBuilderComponentProps) => {
  const {
    connectors: { connect, drag },
  } = useNode();

  return (
    <ContainerPreviewComponent
      {...props}
      connect={connect}
      drag={drag}
    />
  );
};

export default ContainerBuilderComponent;

export const ContainerPreviewComponent = ({ children, connect, drag }: ContainerPreviewComponentProps) => {
  const backgroundColor = useThemeStore(({ backgroundColor }) => backgroundColor);

  return (
    <div
      ref={(ref: any) => (connect && drag ? connect(drag(ref)) : undefined)}
      className="min-h-screen"
      style={{ backgroundColor }}
    >
      {children}
    </div>
  );
};

ContainerBuilderComponent.craft = {
  displayName: "Container",
};
